module.exports = __webpack_public_path__ + "img/banner-sft.95867792.png";